/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminChangePrimaryMembershipRequest } from '@localstack/types';
import type { AdminCreateMembershipRequest } from '@localstack/types';
import type { UpdateMembershipRequest } from '@localstack/types';
import type { UserMembershipView } from '@localstack/types';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MembershipService {
  /**
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static getPrimaryMembership(): CancelablePromise<UserMembershipView> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/users/me/memberships/primary',
    });
  }

  /**
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static listMemberships(): CancelablePromise<Array<UserMembershipView>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/users/me/memberships',
    });
  }

  /**
   * @param userId
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static deleteMember(userId: any): CancelablePromise<UserMembershipView> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/organizations/my/members/{user_id}',
      path: {
        user_id: userId,
      },
    });
  }

  /**
   * @param userId
   * @param requestBody
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static updateMembership(
    userId: any,
    requestBody?: UpdateMembershipRequest,
  ): CancelablePromise<UserMembershipView> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/organizations/my/members/{user_id}',
      path: {
        user_id: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static listMembers(): CancelablePromise<Array<UserMembershipView>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/organizations/my/members',
    });
  }

  /**
   * @param userId
   * @param requestBody
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static adminChangePrimaryMembership(
    userId: any,
    requestBody?: AdminChangePrimaryMembershipRequest,
  ): CancelablePromise<UserMembershipView> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/admin/users/{user_id}/memberships/primary',
      path: {
        user_id: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param userId
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static adminListMemberships(userId: any): CancelablePromise<Array<UserMembershipView>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/admin/users/{user_id}/memberships',
      path: {
        user_id: userId,
      },
    });
  }

  /**
   * @param orgId
   * @param requestBody
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static adminCreateMembership(
    orgId: any,
    requestBody?: AdminCreateMembershipRequest,
  ): CancelablePromise<UserMembershipView> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/admin/orgs/{org_id}/members',
      path: {
        org_id: orgId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param orgId
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static adminListMembers(orgId: any): CancelablePromise<Array<UserMembershipView>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/admin/orgs/{org_id}/members',
      path: {
        org_id: orgId,
      },
    });
  }

  /**
   * @param orgId
   * @param userId
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static adminDeleteMembership(orgId: any, userId: any): CancelablePromise<UserMembershipView> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/admin/orgs/{org_id}/members/{user_id}',
      path: {
        org_id: orgId,
        user_id: userId,
      },
    });
  }

  /**
   * @param orgId
   * @param userId
   * @param requestBody
   * @returns UserMembershipView
   * @throws ApiError
   */
  public static adminUpdateMembership(
    orgId: any,
    userId: any,
    requestBody?: UpdateMembershipRequest,
  ): CancelablePromise<UserMembershipView> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/admin/orgs/{org_id}/members/{user_id}',
      path: {
        org_id: orgId,
        user_id: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
